"use strict";

angular.module("vendor")
.directive('localizedForm', function() {
    return {
        transclude: true,
        templateUrl: require('./localized-form.component.html'),
        controller: function($rootScope, $scope, Language) {
            var _this = this;

            _this.formLanguage = Language.getLanguage();
            refreshFormLanguages();

            $scope.$on("LanguageChanged", function(event, new_locale, new_language) {
                _this.formLanguage = new_language;
                refreshFormLanguages();
            });
            $scope.$on("LanguagesFetched", function(event, languages) {
                refreshFormLanguages();
            });

            function refreshFormLanguages() {
                var languages = $rootScope.languages.slice();

                languages.sort(function(x,y){ return x.ShortCode === _this.formLanguage ? -1 : y.ShortCode === _this.formLanguage ? 1 : 0; });

                $scope.languages = languages;
            }
        },
        controllerAs: 'ctrl'
    };
})

.directive('inject', function() {
    return {
        link: function($scope, $element, $attrs, controller, $transclude) {
            if (!$transclude) {
                throw minErr('ngTransclude')('orphan',
                    'Illegal use of ngTransclude directive in the template! ' +
                    'No parent directive that requires a transclusion found. ' +
                    'Element: {0}',
                    startingTag($element));
            }
            var innerScope = $scope.$new();
            $transclude(innerScope, function(clone) {
                $element.empty();
                $element.append(clone);
                $element.on('$destroy', function() {
                    innerScope.$destroy();
                });
            });
        }
    };
});




//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/localized-form/localized-form.component.js
// module id = 795
// module chunks = 0